import {
  AiDecisioningIcon,
  ReinforcementLearningIcon,
  InsightsIcon,
  ReverseEtlIcon,
  EventCollectionIcon,
  CustomerStudioIcon,
  PersonalizationApiIcon,
  IdentityResolutionIcon,
  MatchBoosterIcon,
} from "ui/icons";
import { type PricingCardProps } from "./card";

export const pricingPlans: Record<PricingCardProps["id"], PricingCardProps> = {
  "ai-decisioning": {
    id: "ai-decisioning",
    heading: "AI Decisioning",
    description: "Plans for teams looking to power 1:1 personalization and targeting with AI Agents.",
    cta: {
      variant: "demo",
      subtext: "Flexible and scalable usage based pricing to meet your growth needs.",
    },
    detailsHeading: "Product features",
    details: [
      {
        icon: AiDecisioningIcon,
        title: "AI Agents",
        href: "/platform/ai-decisioning#ai-agents",
      },
      {
        icon: ReinforcementLearningIcon,
        title: "Reinforcement Learning",
        href: "/blog/rl-agents-for-marketing",
      },
      {
        icon: InsightsIcon,
        title: "Insights",
        href: "/platform/ai-decisioning#insights",
      },
    ],
    included: [
      "Integrations with any marketing platform",
      "Enterprise security",
      "Pre-set amount of monthly personalized actions",
      "Observability features for insights on AI decisions",
    ],
  },
  "composable-cdp": {
    id: "composable-cdp",
    heading: "Composable CDP",
    description: "Plans for teams looking for a full Customer Data Platform solution or a la carte CDP functionality.",
    cta: {
      variant: "demo",
      subtext: "Composable and usage based pricing to ensure you only pay for what you need.",
    },
    detailsHeading: "Product selection",
    details: [
      {
        icon: ReverseEtlIcon,
        title: "Reverse ETL Platform",
        href: "/platform/reverse-etl",
      },
      {
        icon: EventCollectionIcon,
        title: "Hightouch Events",
        href: "/platform/events",
      },
      {
        icon: CustomerStudioIcon,
        title: "Customer Studio",
        href: "/platform/customer-studio",
      },
      {
        icon: PersonalizationApiIcon,
        title: "Real-time Personalization",
        href: "/platform/real-time-personalization",
      },
      {
        icon: IdentityResolutionIcon,
        title: "Identity Resolution",
        href: "/platform/identity-resolution",
      },
      {
        icon: MatchBoosterIcon,
        title: "Match Booster",
        href: "/platform/match-booster",
      },
    ],
    included: [
      "Unlimited user seats",
      "Premium extensions",
      "Advanced observability",
      "Enterprise security",
      "Advanced access management",
      "Dedicated expert support",
      "Custom SLAs",
    ],
  },
  "reverse-etl": {
    id: "reverse-etl",
    direction: "row",
    heading: "Basic Reverse ETL",
    description: "For teams with limited use cases who want to get started with the free tier Reverse ETL Platform.",
    cta: {
      variant: "login",
    },
    included: ["1 standard destination", "Up to 2 active syncs", "5 user seats"],
  },
};
